module.exports = __webpack_public_path__ + "static/img/zanwu.5790391.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zanwu.png
// module id = H5Ch
// module chunks = 1